/**
 * Base error class for all command palette errors.
 * Follows the standard Error pattern with proper error chaining and type safety.
 */
const marker = 'command-palette.error';
const symbol = Symbol.for(marker);

export class CommandPaletteError extends Error {
  private readonly [symbol] = true;
  readonly cause?: unknown;

  constructor({ name, message, cause }: { name: string; message: string; cause?: unknown }) {
    super(message);
    this.name = name;
    this.cause = cause;
  }

  static isInstance(error: unknown): error is CommandPaletteError {
    return CommandPaletteError.hasMarker(error, marker);
  }

  protected static hasMarker(error: unknown, marker_: string): boolean {
    const markerSymbol = Symbol.for(marker_);
    return (
      error !== null &&
      typeof error === 'object' &&
      markerSymbol in error &&
      typeof error[markerSymbol] === 'boolean' &&
      error[markerSymbol]
    );
  }
}
